
<template>
  <div class="social_login_info_wrapper body_7 f_gray_4">
    <img :src="`/static/icons/${provider}_badge.svg`"/>
    {{ this.provider === 'naver' ? '네이버': '카카오' }} 로그인
  </div>
</template>

<script>

import Vue from 'vue'
import AppConfig from '@/config'

export default {
  data(){
	return{
		provider: Vue.$sessionStorage.get('joinChannel') == "N" ? 'naver' : 'kakao',
	}
  },
  /*
  props: {
    provider: {
      type: Vue.$sessionStorage.get('joinChannel') == "N" ? 'naver' | 'kakao',
    }
  }
  */
}
</script>

<style scoped>
.social_login_info_wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiLoginSocial.vue